import { DropCourseSectionsCommand } from '../../../course_scheduler/commands/drop_course_sections_command';
import { RegisterScheduledSectionsCommand } from '../../../course_scheduler/commands/register_scheduled_sections_command';
import { TransientAccessCredEventNames } from '../../../../prevent_transient_access/constants/transient_access_cred_constants';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { HILForm } from '../../../../interfaces/scheduler_interfaces';
import { PreventTransientAccessQuery } from '../../../../prevent_transient_access/queries/prevent_transient_access_query';
import * as _4 from 'lodash4';

import { ICommand } from 'core-ts-types';
import { ScheduledSectionsQuery } from '../../../course_scheduler/queries/scheduled_sections_query';
import { RegisterSectionsQuery } from '../../../course_scheduler/queries/register_sections_query';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { IRegisterSectionsDatasource } from '../../../course_scheduler/datasources/register_sections_datasource';
import { RegistrationPinsModel, IPinSection } from '../../models/registration_pins_model';
import { RegistrationPinsQuery } from './queries/registration_pins_query';
import { SchedulerCustomTextQuery } from '../../../course_scheduler/queries/scheduler_custom_text_query';

class RegistrationPins {
  private open: boolean;
  private tabName: string = 'register';
  private hasError: boolean = false;
  private auto_waitlist_sections = [];
  private errorMessage = '';
  private registerStatusFlags = ['REGISTERED', 'IN_PROGRESS'];
  private hasRegisteredSections: boolean = false;
  private hasScheduledSections: boolean = false;
  private tabGroupIndex: string[] = ['register', 'drop'];
  private dropSectionsBound = this.dropSections.bind(this);
  private registerSectionsBound = this.registerSections.bind(this);
  private closeDialogBound = this.closeDialog.bind(this);

  constructor(
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngRegistrationPinsModel: RegistrationPinsModel,
    private registerScheduledSectionsCommand: RegisterScheduledSectionsCommand,
    private $stateParams: ng.ui.IStateParamsService,
    private $element: ng.IAugmentedJQuery,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private dropCourseSectionsCommand: DropCourseSectionsCommand,
    private ngRegistrationPinsQuery: RegistrationPinsQuery,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}
  $onInit() {
    this.hasRegisteredSections =
      this.ngScheduledSectionsQuery.result.registeredSections.length > 0 ||
      this.ngScheduledSectionsQuery.result.registeredMultiSections.length > 0;
    this.hasScheduledSections =
      this.ngScheduledSectionsQuery.result.scheduledSections.length > 0 ||
      this.ngScheduledSectionsQuery.result.scheduledMultiSections.length > 0;
    const { scheduledSections, scheduledMultiSections, registeredSections, registeredMultiSections } =
      this.ngScheduledSectionsQuery.result;
    const allSections: IPinSection[] = _4.compact(
      _4.map(
        [...scheduledSections, ...scheduledMultiSections, ...registeredSections, ...registeredMultiSections],
        (section: ISection) => ({
          sectionId: section.id,
          status: this._sectionStatus(section.status),
          courseId: section.course,
          is_selected: false
        })
      )
    );
    this.ngRegistrationPinsModel.write({ _registration_pins_sections: allSections });
    this.ngRegistrationPinsModel.clear();
    this.ngRegistrationPinsQuery.run();
    this.ngComponentCommunicatorService.subscribe(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
  }
  _sectionStatus(status: string): string {
    return _4.includes(this.registerStatusFlags, status) ? 'REGISTERED' : status;
  }
  showTab(event: any) {
    this.tabName = this.tabGroupIndex[_4.get(event, 'target.selectedIndex', 0)];
    this.hasError = false;
    this.errorMessage = '';
  }
  isSelected(selectedTabName: string) {
    return this.tabName === selectedTabName;
  }
  closeDialog() {
    this.open = false;
    this.ngRegistrationPinsModel.clear();
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.NEW_CRED_SAVED,
      this.registerSectionsBound
    );
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
  }

  onDialogCloseEnded(event: CustomEvent) {
    this.closeDialog();
  }

  isFormInvalid() {
    const formElement = this.$element[0].querySelector('hi-form') as HILForm;
    formElement.output = undefined;
    formElement.submit();
    return _4.isEmpty(formElement.output);
  }

  validRegistration() {
    const isFormInvalid = this.isFormInvalid();
    if (this.ngRegistrationPinsQuery.result.disableRegisterAction || isFormInvalid) {
      this.hasError = true;
      this.errorMessage = 'Select a valid section to register or drop.';
      return false;
    }
    this.clearErrorMessage();
    return true;
  }
  registerSections() {
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.NEW_CRED_SAVED,
      this.registerSectionsBound
    );
    if (!this.validRegistration()) {
      return;
    }

    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      this.ngComponentCommunicatorService.subscribe(
        TransientAccessCredEventNames.NEW_CRED_SAVED,
        this.registerSectionsBound
      );
      return this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
    }
    const { sections, section_pins } = this.ngRegistrationPinsModel.getScheduledSectionsInfo();
    this.registerScheduledSectionsCommand(
      this.$stateParams.termId,
      sections,
      this.auto_waitlist_sections,
      section_pins,
      {},
      this.ngPreventTransientAccessQuery.result.output
    );
    this.closeDialog();
  }

  clearErrorMessage() {
    this.hasError = false;
    this.errorMessage = '';
  }
  validDrop() {
    const isFormInvalid = this.isFormInvalid();
    if (this.ngRegistrationPinsQuery.result.disableDropAction || isFormInvalid) {
      this.hasError = true;
      this.errorMessage = 'Select a valid section to register or drop.';
      return false;
    }
    this.clearErrorMessage();
    return true;
  }

  dropSections() {
    if (!this.validDrop()) {
      return;
    }
    const sessionId = -1;

    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      this.ngComponentCommunicatorService.subscribe(
        TransientAccessCredEventNames.NEW_CRED_SAVED,
        this.dropSectionsBound
      );
      return this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
    }
    this.errorMessage = '';
    const { section_pins, courseIds, sections } = this.ngRegistrationPinsModel.getRegisterSectionsInfo();
    this.dropCourseSectionsCommand(
      this.$stateParams.termId,
      courseIds,
      false,
      sessionId,
      section_pins,
      sections,
      this.ngPreventTransientAccessQuery.result.output
    );
    this.closeDialog();
  }

  alertClosed() {
    this.clearErrorMessage();
  }

  getShouldShowControls() {
    const sectionPinStepGroupEl = this.$element[0].querySelector('hi-step-group');
    if (!sectionPinStepGroupEl) {
      return true;
    }
    const stepValue = sectionPinStepGroupEl.getAttribute('value');
    const isStepValueChooseAction = stepValue === 'choose-action';
    return isStepValueChooseAction;
  }
}

class RegistrationPinsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      open: '='
    };
    this.controller = RegistrationPins;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_pins/registration_pins_component.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationPins', new RegistrationPinsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pins/registration_pins_component.ts